import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/contact-modal/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/contact-modal/enum.model';
import { SimpleResponse } from '../../../models/contact-modal/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/contact-modal/roleContainer.model';
import { EngageMetricListResponse, EngageMetricModel } from '../../../models/contact-modal/engage-metric.model';
import { AuthenticateService } from '../../../services/contact-services/authenticate.service';
import { GlobalService } from '../../../services/contact-services/global.service';
import { NotificationService } from '../../../services/contact-services/notification.service';
import { GridConfigurationService } from '../../../services/contact-services/shared/gridConfiguration.service';
import { LocalService } from '../../../services/contact-services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/contact-services/shared/utility.service';
import { EngageMetricService } from '../../../services/contact-services/engage-metric.service';
import { UserService } from '../../../services/contact-services/user.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any

@Component({
    selector: 'app-engage-metric',
    templateUrl: './engage-metric.component.html',
    styleUrl: './engage-metric.component.css',
    providers: [GridConfigurationService]
})
export class EngageMetricComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    engageMetricListSource: MatTableDataSource<any>;
    engageMetricListDisplayColumns: string[];
    encryptedUser: string = '';
    userResponse: UserResponse;
    user: CLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    @Input() contactId: number = 0;
    editedRowIndex: number;
    engageMetricList: EngageMetricModel[];
    engageMetricID: number = 0;
    contactID: number;
    metricName: string;
    metricValue: string;
    dtCreated: string;
    columns = [
        { field: '$', title: ' ', width: '35' },
        { field: 'metricName', title: 'Metric', width: '180' },
        { field: 'metricValue', title: 'Value', width: '180' },
        { field: 'dtCreated', title: 'Created', width: '160' },
        { field: 'action', title: 'Action', width: '160' },
    ];

    reorderColumnName: string = 'metricName,metricValue,dtCreated';
    columnWidth: string = 'metricName:180,metricValue:180,dtCreated:160';
    arrColumnWidth: any = ['metricName:180,metricValue:180,dtCreated:160'];
    @Output() isCloseButton = new EventEmitter<boolean>();
    constructor(
        private _utilityService: UtilityService,
        public _localService: LocalService,
        private _route: ActivatedRoute,
        private notifyService: NotificationService,
        private _router: Router,
        private _userService: UserService,
        private _authenticateService: AuthenticateService,
        private engageMetricService: EngageMetricService,
        public _gridCnfgService: GridConfigurationService,
        private _globalService: GlobalService,) {

    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(async () => {
                    if (this.user) {
                        this.engageMetric_LoadByContactID();
                    }
                    else {
                        this._router.navigate(['/login']);
                    }
                });
            }
            else {
                this._router.navigate(['/login']);
            }
        });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact.authenticateR", err.message, null,
                    'Feature: ' + eFeatures.ViewMyContacts
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async engageMetric_LoadByContactID() {
        await this.engageMetricService.engageMetric_LoadByContactID(this.encryptedUser, this.user.cLPCompanyID, this.user?.cLPUserID, this.contactId)
            .then(async (result: EngageMetricListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.engageMetricList = response?.engageMetricList;
                    this.setGrid(this.engageMetricList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("engage-metric.engageMetric_LoadByContactID", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async engageMetric_Delete() {
        await this.engageMetricService.engageMetric_Delete(this.encryptedUser, this.user.cLPCompanyID, this.user?.cLPUserID, this.engageMetricID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this.cancel();
                        this.engageMetric_LoadByContactID()
                        this.notifyService.showSuccess("EngageMetric Deleted", "", 3000);
                    }
                    else {
                        this.notifyService.showError("Some error occured. Try Again.", "", 3000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("engage-metric.engageMetric_Delete", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'engage_metric_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('engage_metric_grid').subscribe((value) => { }));
    //}

    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'engage_metric_grid').subscribe((value) => this.getGridConfiguration());
    //}

    public editHandlerNewUser(rowIndex, dataItem) {
        this.editedRowIndex = rowIndex;
    }


    public cancelHandlerNewUser({ sender, rowIndex }) {
        this.editedRowIndex = -1;
    }

    //private closeEditorNewUser(grid, rowIndex = this.editedRowIndex) {
    //    grid.closeRow(rowIndex);
    //    this.editedRowIndex = undefined;
    //}

    public saveHandlerNewUser(dataItem): void {
        this.engageMetricService.engageMetric_UpdateValue(this.encryptedUser, this.user.cLPCompanyID, this.user?.cLPUserID, dataItem?.engageMetricID, dataItem?.metricValue)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this.notifyService.showSuccess("EngageMetric Value Updated", "", 3000);
                        this.editedRowIndex = -1;
                    }
                    else {
                        this.notifyService.showError("Some error occured. Try Again.", "", 3000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("engage-metric.saveHandlerNewUser", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    onClose() {
        this.isCloseButton.emit(true);
    }

    public removeHandler({ dataItem }): void {
        this.engageMetricID = dataItem?.engageMetricID;
    }

    cancel() {
        $('#confirmDeleteModal').modal('hide');
    }

    setGrid(list) {
        this.engageMetricListDisplayColumns = this.columns.map(c => c.field);
        this.engageMetricListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.engageMetricListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 10;
            }
            if (this.sort) {
                this.engageMetricListSource.sort = this.sort;
            }

        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}

